import { render, staticRenderFns } from "./FormItemNumber.vue?vue&type=template&id=912b39ce&scoped=true"
import script from "./FormItemNumber.vue?vue&type=script&lang=js"
export * from "./FormItemNumber.vue?vue&type=script&lang=js"
import style0 from "./FormItemNumber.vue?vue&type=style&index=0&id=912b39ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912b39ce",
  null
  
)

export default component.exports